// @flow
import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router'
import get from 'lodash/get'
import { displayStatus, pluralize } from '../../utils'
import media from '../../styles/media'
import colors from '../../styles/colors'
import Card from '../../components/Card'
import StatusTag from '../../components/StatusTag'
import Button from '../../components/Button'

const Container = styled.div`
  width: 100%;
  padding: 0 1rem;
  ${media.mdUp} {
    width: 50%;
  }
`

const IframeContainer = styled.div`
  cursor: pointer;
`

const Iframe = styled.iframe`
  pointer-events: none;
  display: block;
  margin: auto;
  width: 100%;
  min-height: 300px;
`

const FallbackImage = styled.img`
  width: 100%;
`

const IframeClickOverlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`

const ButtonRow = styled.div`
  margin-top: 1rem;
  text-align: right;
  > * {
    margin-top: 3px;
    margin-right: 3px;
  }
`

type Props = {
  property: Object,
  onRequestOpenVirtualTour: Function,
  onRequestOpenContactModal: Function,
  onClickScheduleTour: Function
}

const TourCard = ({
  property,
  onRequestOpenVirtualTour,
  onRequestOpenContactModal,
  onClickScheduleTour
}: Props) => {
  const iframeSrc = property.virtualTourUrl
  // reallustrations disables embedding iframes from other origins,
  // so show an image instead an open the tour in another tab when clicked
  const disableIframe =
    iframeSrc && iframeSrc.match('https://media.reallustrations.com')
  const fallbackImgSrc = get(
    property,
    ['photos', 0],
    '/static/images/default-home-marker.png'
  )

  function onOpenTour() {
    onRequestOpenVirtualTour({ src: iframeSrc })
  }

  return (
    <Container>
      <Card>
        <div className="row">
          <div className="col-md-6 col-xs-12">
            {disableIframe ? (
              <a
                href={property.virtualTourUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FallbackImage src={fallbackImgSrc} role="presentation" />
              </a>
            ) : (
              <IframeContainer>
                <Iframe src={iframeSrc} frameBorder="0" allowFullScreen />
                <StatusTag status={property.mls.status}>
                  {displayStatus(property.mls.status)}
                </StatusTag>
                <IframeClickOverlay onClick={onOpenTour} />
              </IframeContainer>
            )}
          </div>
          <div className="col-md-6 col-xs-12">
            <div style={{ marginBottom: '10px' }}>
              <Link
                to={`/properties/${property.mlsId}`}
                style={{ color: 'inherit' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <div>{property.address.full}</div>
              </Link>
              <div>
                <small style={{ color: 'rgb(120,130,140)' }}>
                  {property.address.city}, {property.address.state}{' '}
                  {property.address.postalCode}
                </small>
              </div>
            </div>
            <div>
              <span style={{ color: colors.success, marginRight: '5px' }}>
                ${Number(property.listPrice).toLocaleString()}
              </span>
              <span className="fa fa-home" style={{ marginRight: '5px' }} />
              <span style={{ marginRight: '5px' }}>
                {property.property.bedrooms} bd
              </span>
              <span style={{ marginRight: '5px' }}>
                {property.property.bathrooms} ba
              </span>
              <span>{Number(property.property.area).toLocaleString()} sf</span>
            </div>
            {property.remarks && (
              <div>
                <hr />
                <div style={{ fontSize: '13px' }}>
                  {property.remarks && property.remarks.slice(0, 150)}
                  {property.remarks && property.remarks.length > 150 && '...'}
                </div>
              </div>
            )}
            <hr />
            <div style={{ fontSize: '80%' }}>
              <div>
                <span
                  className="fa fa-clock-o"
                  style={{ marginRight: '5px' }}
                />
                <span>
                  {property.mls.daysOnMarket}{' '}
                  {pluralize(property.mls.daysOnMarket, 'day')} on the market
                </span>
              </div>
              <div>Listing courtesy of {property.office.name}</div>
            </div>
            <ButtonRow>
              <Button
                small
                type="button"
                onClick={() => onClickScheduleTour(property)}
              >
                Schedule Viewing
              </Button>
              <Button
                small
                type="button"
                onClick={() => {
                  onRequestOpenContactModal({
                    location: `${window.location.origin}/properties/${property.mlsId}`
                  })
                }}
              >
                Contact
              </Button>
              <Button
                small
                to={`/properties/${property.mlsId}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Details
              </Button>
            </ButtonRow>
          </div>
        </div>
      </Card>
    </Container>
  )
}

export default TourCard



// WEBPACK FOOTER //
// ./src/views/PropertyTours/TourCard.js